<template>
  <div
    class="wrapper pa-4"
  >
    <h1>添加文字</h1>
    <div class="relative full-bleed">
      <canvas
        id="c3"
        style="border: 1px solid;max-height: 65vh;width: 100%;"
      />
      <span class="text">1. html文字定位到 canvas里</span>
    </div>
    <h2>代码</h2>
    <p>1. html文字定位到 canvas里</p>
      
    <p>DOM + CSS</p>
      
    <highlightjs
      class="mt-4"
      :code="`.text {
  /* 直接定位到 canvas里 */
  z-index: 9999;
  position: absolute;
  top: 80px;
  left: 45%;
  grid-column: 2;
  color: white;
}`"
      :language="'css'"
    />
    <p>
      2. 将文字绘制到画布中，并将其用作Texture（纹理）<br>
      其实加载一个图片 <a href="https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg">https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg</a>
      <highlightjs
        class="mt-4"
        :code="`{
  // 2. 将文字绘制到画布中，并将其用作Texture（纹理）
  // 我是文字.jpg
  const texture = new THREE.TextureLoader().load( 'https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg' );
  const material = new THREE.MeshBasicMaterial( { map: texture } );
  const geometry = new THREE.PlaneGeometry( 3, 3 );
  const mesh = new THREE.Mesh( geometry, material );
  // 位置
  mesh.position.set( 2, 1.5 , -3 );
  // 双面显示
  mesh.material.side = THREE.DoubleSide;
  this.scene.add( mesh );
}`"
        :language="'js'"
      />
    </p>

    <p>
      3. three.js自带的文字几何体<br>
      参考GitHub 代码
      <highlightjs
        class="mt-4"
        :code="`{
  // 3. three.js自带的文字几何体
  const scene = this.scene;
  // 1. loadFont
  let font = null;
  const loader = new FontLoader();
  loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( _font ) {
    font = _font;
    console.log( font , 'font loaded');
    // 2. 创建文字几何体
    const textGeo = new TextGeometry( 'Aa.字', {
      font: font,
      size: 0.8, // 文字大小
      height: 0.2, // 文字厚度
      // curveSegments: 6, // 曲线段数
      // bevelThickness: 0.1, // 斜角厚度
      // bevelSize: 0.08, // 斜角大小
      // bevelEnabled: true // 是否斜角
    });
    textGeo.computeBoundingBox();

    // 3. 创建文字材质
    const textMaterial = new THREE.MeshBasicMaterial( { color: '#ffdd11' } );
    const textMesh = new THREE.Mesh( textGeo, textMaterial );
    textMesh.position.set( -1, 1 , -2 );
    
    scene.add( textMesh );
  })
}`"
        :language="'js'"
      />
    </p>
    <h2>参考</h2>
    <p>
      <a href="https://threejs.org/docs/index.html#manual/zh/introduction/Creating-text">创建文字（Creating text）</a>
    </p>
    <p>
      <a href="https://github.com/mrdoob/three.js/blob/master/examples/webgl_geometry_text.html">代码webgl_geometry_text.html</a>
    </p>
  </div>
</template>

<script>
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js';
// eslint-disable-next-line
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js';

export default {
  data() {
    return {
      state3: {
        time: 0,
      },
      renderer3: null,
      scene: null,
      camera: null,
    };
  },
  mounted() {
    this.init3();
    this.animate3();
  },
  // 组件销毁
  beforeDestroy() {
    // 销毁？？
    this.renderer.dispose();
  },
  methods: {
    init3() {
      // canvas
      const canvas = document.querySelector('#c3');
      // 渲染器 antialias代表是否开启抗锯齿
      this.renderer = new THREE.WebGLRenderer({antialias: true, canvas});
      this.camera = new THREE.PerspectiveCamera(100, 2, 0.1, 80);

      // 摄像机位置 xyz
      this.camera.position.set( -1, 0.5, 3);
      // this.camera.lookAt( 0, 0, 0 );

      const controls = new OrbitControls( this.camera, canvas );
      // target
      controls.target.set( 0, 0, 0 );
      controls.update();
      
      // 创建场景
      this.scene = new THREE.Scene();
      this.scene.background = new THREE.Color( 'black' );

      {
        // 2. 将文字绘制到画布中，并将其用作Texture（纹理）
        // 我是文字.jpg
        const texture = new THREE.TextureLoader().load( 'https://cdn.jsdelivr.net/gh/miloweimo/blogimage/text.jpg' );
        const material = new THREE.MeshBasicMaterial( { map: texture } );
        const geometry = new THREE.PlaneGeometry( 3, 3 );
        const mesh = new THREE.Mesh( geometry, material );
        // 位置
        mesh.position.set( 2, 1.5 , -3 );
        // 双面显示
        mesh.material.side = THREE.DoubleSide;
        this.scene.add( mesh );
      }

      {
        // 3. three.js自带的文字几何体
        const scene = this.scene;
        // 1. loadFont
        let font = null;
        const loader = new FontLoader();
        loader.load( 'https://threejs.org/examples/fonts/helvetiker_regular.typeface.json', function ( _font ) {
          font = _font;
          console.log( font , 'font loaded');
          // 2. 创建文字几何体
          const textGeo = new TextGeometry( 'Aa.字', {
            font: font,
            size: 0.8, // 文字大小
            height: 0.2, // 文字厚度
            // curveSegments: 6, // 曲线段数
            // bevelThickness: 0.1, // 斜角厚度
            // bevelSize: 0.08, // 斜角大小
            // bevelEnabled: true // 是否斜角
          });
          textGeo.computeBoundingBox();
  
          // 3. 创建文字材质
          const textMaterial = new THREE.MeshBasicMaterial( { color: '#ffdd11' } );
          const textMesh = new THREE.Mesh( textGeo, textMaterial );
          textMesh.position.set( -1, 1 , -2 );
          
          scene.add( textMesh );
        })
      }


      {
        const planeSize = 10;
        const loader = new THREE.TextureLoader();
        const texture = loader.load( 'https://threejs.org/manual/examples/resources/images/checker.png' );
        texture.wrapS = THREE.RepeatWrapping;
        texture.wrapT = THREE.RepeatWrapping;
        texture.magFilter = THREE.NearestFilter;
        //texture.colorSpace = THREE.SRGBColorSpace;
        const repeats = planeSize / 2;
        texture.repeat.set( repeats, repeats );

        const planeGeo = new THREE.PlaneGeometry( planeSize, planeSize );
        const planeMat = new THREE.MeshPhongMaterial( {
          map: texture,
          side: THREE.DoubleSide,
        } );
        const mesh = new THREE.Mesh( planeGeo, planeMat );
        mesh.rotation.x = Math.PI * - .5;
        this.scene.add( mesh );
      }


      // 场景+灯光
      const color = 0xFFFFFF;
      const intensity = 3;
      const light = new THREE.DirectionalLight(color, intensity);
      light.position.set(-1, 2, 4); // 位置
      this.scene.add(light);
      const light2 = new THREE.DirectionalLight(color, intensity);
      light2.position.set(1, -2, 4); // 位置
      this.scene.add(light2);
      const light3 = new THREE.DirectionalLight(color, intensity);
      light3.position.set(1, 3, 4); // 位置
      this.scene.add(light3);
      const light4 = new THREE.DirectionalLight(color, intensity);
      light4.position.set(-1, -3, 4); // 位置
      this.scene.add(light4);

      // 之后将场景和摄像机传递给渲染器来渲染出整个场景。
      this.renderer.render(this.scene, this.camera);
    },
    updateCamera() {
      this.camera.updateProjectionMatrix();
    },

    // 判断画布是否需要调整大小
    resizeRendererToDisplaySize(renderer) {
      const canvas = renderer.domElement;
      const width = canvas.clientWidth;
      const height = canvas.clientHeight;
      const needResize = canvas.width !== width || canvas.height !== height;
      if (needResize) {
        renderer.setSize(width, height, false);
      }
      return needResize;
    },
    render3() {
      // 注意如果我们的canvas大小被调整了那函数会返回true。我们可以利用 这个来检查是否有其他的东西应该更新。我们修改渲染循环 来使用我们的新函数
      if (this.resizeRendererToDisplaySize(this.renderer)) {
        const canvas = this.renderer.domElement;
        this.camera.aspect = canvas.clientWidth / canvas.clientHeight;
        this.camera.updateProjectionMatrix();
      }

      this.renderer.render(this.scene, this.camera);

      requestAnimationFrame(this.render3);
    },
    animate3(time) {
      this.state3.time = time * 0.01;
      this.render3();
    
      requestAnimationFrame(this.animate3);
    },
  }
}
</script>

<style scoped>
.wrapper {
  display: grid;
  grid-template-columns:
    1fr
    min(65ch, 100%)
    1fr;
}

.wrapper > * {
  grid-column: 2;
}

.full-bleed {
  width: 100%;
  grid-column: 1 / -1;
}

/* 移动端换行 */
a {
  word-break: break-all;
}

.text {
  /* 直接定位到 canvas里 */
  z-index: 9999;
  position: absolute;
  top: 80px;
  left: 45%;
  grid-column: 2;
  color: white;
}

</style>